import { render, staticRenderFns } from "./BackgroundSettings.vue?vue&type=template&id=6f57c508&scoped=true&"
import script from "./BackgroundSettings.vue?vue&type=script&lang=js&"
export * from "./BackgroundSettings.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundSettings.vue?vue&type=style&index=0&id=6f57c508&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f57c508",
  null
  
)

export default component.exports